import womanBrowsing from './woman-browsing.webp';
import womanScrolling from './woman-scrolling.webp';
import manSmilingAtPhone from './man-smiling-at-phone.webp';
import manListeningIntently from './man-listening-intently.webp';
import headphones from './headphones.webp';
import elderlyManWithHeadphones from './elderly-man-with-headphones.webp';
import womanTypingOnLaptop from './woman-typing-on-laptop.webp';
export var pageImages = {
    manListeningIntently: manListeningIntently,
    womanBrowsing: womanBrowsing,
    womanScrolling: womanScrolling,
    manSmilingAtPhone: manSmilingAtPhone,
    headphones: headphones,
    elderlyManWithHeadphones: elderlyManWithHeadphones,
    womanTypingOnLaptop: womanTypingOnLaptop,
};
